export const breadcrumbTheme = {
  root: {
    background: 'transparent',
    padding: '0.75rem 0',
    transitionDuration: '0.2s'
  },
  item: {
    borderRadius: '{content.border.radius}',
    gap: '0.5rem',
    focusRing: {
      width: '2px',
      style: 'solid',
      color: '{primary.color}',
      offset: '2px',
      shadow: '{focus.ring.shadow}'
    }
  },
  colorScheme: {
    light: {
      item: {
        color: '{text.muted.color}',
        hoverColor: '{text.color}',
        icon: {
          color: '{text.muted.color}',
          hoverColor: '{text.color}'
        }
      },
      separator: {
        color: '{text.muted.color}'
      }
    },
    dark: {
      item: {
        color: '{gray.0}',
        hoverColor: '{gray.0}',
        icon: {
          color: 'rgba(255, 255, 255, 0.8)',
          hoverColor: '{gray.0}'
        }
      },
      separator: {
        color: 'rgba(255, 255, 255, 0.6)'
      }
    }
  }
};
